import { render, staticRenderFns } from "./Call.vue?vue&type=template&id=f6891d8e&scoped=true&"
import script from "./Call.vue?vue&type=script&lang=ts&"
export * from "./Call.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6891d8e",
  null
  
)

export default component.exports